import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, $element) {
    function setElementVisibility(isVisible) {
        $scope.sideBarMenuVisible = isVisible;
        $element.toggleClass('gw-slidebar-menu-open', isVisible);
    }

    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.sideBarMenuVisible = false;
    };

    ctrl.toggleSideBarMenu = function () {
        setElementVisibility(!$scope.sideBarMenuVisible);
    };

    ctrl.hideSideBarMenu = function () {
        setElementVisibility(false);
    };

    ctrl.showSideBarMenu = function () {
        setElementVisibility(true);
    };

    ctrl.isSideBarMenuVisible = function () {
        return $scope.sideBarMenuVisible;
    };

    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$element'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/wizard/NavBarWizardBaseCtrl.js
// module id = 326
// module chunks = 0